import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.echomemoir.ai/api';

const GiftRedeem = () => {
  const navigate = useNavigate();

  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(null);

  const isLoggedIn = !!localStorage.getItem('token');

  const handleRedeem = async () => {
    setError('');
    const trimmed = code.trim().toUpperCase();

    if (!trimmed) {
      setError('Please enter a gift code.');
      return;
    }

    if (!isLoggedIn) {
      setError('You need to sign in before redeeming a gift code.');
      return;
    }

    setSubmitting(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/billing/redeem-gift`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ code: trimmed })
      });

      const data = await res.json();

      if (res.ok && data.success) {
        setSuccess(data);
      } else {
        setError(data.error || 'Failed to redeem gift code.');
      }
    } catch (err) {
      console.error('Redeem error:', err);
      setError('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  // Success state
  if (success) {
    const planEmoji = success.tier === 'legacy_vault' ? '🏛️' : '🌳';
    return (
      <div style={{
        minHeight: '100vh', background: '#08060e', color: '#fff',
        padding: '60px 20px', display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <div style={{ maxWidth: '460px', width: '100%', textAlign: 'center' }}>
          <div style={{
            width: '80px', height: '80px', borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(34,197,94,0.2), rgba(16,185,129,0.1))',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 24px', fontSize: '40px'
          }}>
            🎉
          </div>

          <h1 style={{ fontSize: '26px', fontWeight: '700', marginBottom: '8px' }}>
            Gift Activated!
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '15px', lineHeight: '1.6', marginBottom: '28px' }}>
            Your <strong style={{ color: '#fbbf24' }}>{success.planName}</strong> subscription is now active for {success.durationMonths} months.
          </p>

          <div style={{
            background: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.2)',
            borderRadius: '14px', padding: '20px', marginBottom: '28px'
          }}>
            <p style={{ color: '#4ade80', fontSize: '14px', fontWeight: '600', marginBottom: '6px' }}>
              {planEmoji} {success.planName}
            </p>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '13px', margin: 0 }}>
              Active until {new Date(success.expiresAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          <button
            onClick={() => navigate('/')}
            style={{
              padding: '14px 32px', borderRadius: '12px', border: 'none',
              background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
              color: '#fff', fontSize: '16px', fontWeight: '600', cursor: 'pointer'
            }}
          >
            Start Exploring 🚀
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#08060e', color: '#fff',
      padding: '60px 20px', display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{ maxWidth: '440px', width: '100%' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <button
            onClick={() => navigate('/')}
            style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', fontSize: '14px', cursor: 'pointer', marginBottom: '20px', display: 'inline-block' }}
          >
            ← Back
          </button>
          <div style={{
            width: '72px', height: '72px', borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(251,191,36,0.15), rgba(139,92,246,0.1))',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 20px', fontSize: '36px'
          }}>
            🎁
          </div>
          <h1 style={{ fontSize: '26px', fontWeight: '700', marginBottom: '8px' }}>
            Redeem Gift Code
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px', lineHeight: '1.6' }}>
            Enter your gift code to activate your EchoMemoir subscription.
          </p>
        </div>

        {!isLoggedIn && (
          <div style={{
            background: 'rgba(251,191,36,0.08)', border: '1px solid rgba(251,191,36,0.2)',
            borderRadius: '12px', padding: '16px', marginBottom: '20px', textAlign: 'center'
          }}>
            <p style={{ color: '#fbbf24', fontSize: '14px', marginBottom: '12px' }}>
              You need an account to redeem a gift code.
            </p>
            <button
              onClick={() => navigate('/signup')}
              style={{
                padding: '10px 20px', borderRadius: '8px', border: 'none',
                background: '#fbbf24', color: '#08060e',
                fontSize: '14px', fontWeight: '600', cursor: 'pointer', marginRight: '10px'
              }}
            >
              Create Account
            </button>
            <button
              onClick={() => navigate('/login')}
              style={{
                padding: '10px 20px', borderRadius: '8px',
                border: '1px solid rgba(251,191,36,0.3)', background: 'transparent',
                color: '#fbbf24', fontSize: '14px', cursor: 'pointer'
              }}
            >
              Sign In
            </button>
          </div>
        )}

        {error && (
          <div style={{
            background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)',
            borderRadius: '10px', padding: '12px 16px', marginBottom: '20px',
            color: '#fca5a5', fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        {/* Code input */}
        <div style={{ marginBottom: '20px' }}>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            placeholder="GIFT-XXXX-XXXX"
            maxLength={14}
            style={{
              width: '100%', padding: '16px', borderRadius: '12px',
              background: 'rgba(255,255,255,0.06)', border: '2px solid rgba(251,191,36,0.2)',
              color: '#fbbf24', fontSize: '22px', fontWeight: '700',
              letterSpacing: '3px', textAlign: 'center', fontFamily: 'monospace',
              outline: 'none', boxSizing: 'border-box'
            }}
            onFocus={(e) => e.target.style.borderColor = 'rgba(251,191,36,0.5)'}
            onBlur={(e) => e.target.style.borderColor = 'rgba(251,191,36,0.2)'}
          />
        </div>

        {/* Redeem button */}
        <button
          onClick={handleRedeem}
          disabled={submitting || !isLoggedIn || !code.trim()}
          style={{
            width: '100%', padding: '16px', borderRadius: '12px', border: 'none',
            background: (submitting || !isLoggedIn || !code.trim())
              ? 'rgba(139,92,246,0.2)'
              : 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
            color: '#fff', fontSize: '16px', fontWeight: '600',
            cursor: (submitting || !isLoggedIn || !code.trim()) ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s ease'
          }}
        >
          {submitting ? 'Redeeming...' : '🎁 Redeem Gift Code'}
        </button>

        <p style={{ color: 'rgba(255,255,255,0.25)', fontSize: '12px', textAlign: 'center', marginTop: '20px', lineHeight: '1.6' }}>
          Gift codes are valid for 1 year from purchase. Each code can only be used once.
          <br />
          Don't have a code? <span onClick={() => navigate('/gift')} style={{ color: '#a78bfa', cursor: 'pointer' }}>Buy a gift subscription</span>
        </p>
      </div>
    </div>
  );
};

export default GiftRedeem;
